import React from "react";
import Stagetrade from "../templates/trade/stage";
import Stagebrand from "../templates/brand/stage";
import Stagesimplebrand from "../templates/simplebrand/stage";
import GamStandard from "../templates/adaptive/stage";
import KevelStandard from "../templates/kevel/stage";
import Stagehybrid from "../templates/hybrid/stage";

const comps = {
  Stagetrade,
  Stagebrand,
  Stagesimplebrand,
  GamStandard,
  KevelStandard,
  Stagehybrid,
};

const CompManager = (props) => {
  let renderComp;

  const { compName } = props;
  const Component = comps[compName];
  if (Component) renderComp = <Component {...props} />;

  return <>{renderComp}</>;
};

export default CompManager;
